import * as actionTypes from 'actions';

const initialState = {
  saved: false,
  savedVenueWebhook: {},
  deleted: false,
  deletedVenueWebhook: {},
  venueWebhook: {
    venue: null,
    url: '',
    secret: ''
  },
  venues: [],
  validationMessages: {},
  saving: false
};

const venueWebhookCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_VENUE_WEBHOOK_PENDING: {
      return {
        ...state,
        saving: true
      };
    }

    case actionTypes.SAVE_VENUE_WEBHOOK_FULFILLED: {
      return {
        ...state,
        saved: action.payload.data.success,
        savedVenueWebhook: action.payload.data.result,
        validationMessages: action.payload.data.validationMessages,
        saving: false
      };
    }

    case actionTypes.DELETE_VENUE_WEBHOOK_FULFILLED: {
      return {
        ...state,
        deleted: action.payload.data.success,
        deletedVenueWebhook: action.payload.data.result
      };
    }

    case actionTypes.EDIT_VENUE_WEBHOOK_FULFILLED: {
      return {
        ...state,
        venueWebhook: action.payload.data.result
      };
    }

    case actionTypes.FIND_VENUES_PENDING: {
      return {
        ...state,
        venues: initialState.venues
      };
    }

    case actionTypes.FIND_VENUES_FULFILLED: {
      return {
        ...state,
        venues: action.payload.data.result
      };
    }

    case actionTypes.CREATE_VENUE_WEBHOOK_VALUE_RESET: {
      return {
        ...initialState
      };
    }

    case actionTypes.CREATE_VENUE_WEBHOOK_VALUE_UPDATE: {
      return {
        ...state,
        venueWebhook: {
          ...state.venueWebhook,
          ...action.payload
        }
      };
    }

    default: {
      return state;
    }
  }
};

export default venueWebhookCreateReducer;
